(function () {
  if (customElements.get('ce-sticky-scroll-header') !== undefined) {
    return;
  }

  class StickyScrollHeader extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        marker: '[data-sticky-scroll-header-marker]',
        markerBottom: '[data-sticky-scroll-header-marker][data-position="bottom"]',
        section: '.shopify-section.shopify-section-group-group-header[id$="__header"]',
        header: '[data-sticky-scroll-header-header]',
      };

      this.elements = null;

      this.attributesFrozen = false;

      this._handleFreeze = this._handleFreeze.bind(this);
      this._handleUnfreeze = this._handleUnfreeze.bind(this);
      this._handleScrollWindow = this._handleScrollWindow.bind(this);
    }

    get behavior() {
      return this.getAttribute('behavior');
    }

    set behavior(value) {
      this.setAttribute('behavior', value);
    }

    get scrollDirection() {
      return this.getAttribute('scroll-direction');
    }

    set scrollDirection(value) {
      this.setAttribute('scroll-direction', value);
    }

    static get observedAttributes() {
      return ['behavior', 'scroll-direction'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'behavior':
          if (newValue !== null) {
            if (newValue === 'static') {
              requestAnimationFrame(() => {
                this.elements.section.classList.replace('behavior-sticky', 'behavior-static');
              });
            } else {
              requestAnimationFrame(() => {
                this.elements.section.classList.replace('behavior-static', 'behavior-sticky');

                this.elements.section.classList.add('no-transition');
                setTimeout(() => {
                  this.elements.section.classList.remove('no-transition');
                }, 50);
              });
            }
          }
          break;
        case 'scroll-direction':
          if (newValue !== null) {
            if (newValue === 'down') {
              requestAnimationFrame(() => {
                this.elements.section.classList.replace('scroll-direction-up', 'scroll-direction-down');
              });

              document.dispatchEvent(new CustomEvent('ce-sticky-scroll-header:scroll-direction', { detail: newValue }));
            } else {
              requestAnimationFrame(() => {
                this.elements.section.classList.replace('scroll-direction-down', 'scroll-direction-up');
              });
            }
          }
          break;
      }
    }

    parsedCallback() {
      const markerTop = document.createElement('div');
      markerTop.setAttribute('data-sticky-scroll-header-marker', '');
      markerTop.setAttribute('data-position', 'top');

      const markerBottom = document.createElement('div');
      markerBottom.setAttribute('data-sticky-scroll-header-marker', '');
      markerBottom.setAttribute('data-position', 'bottom');

      const section = document.querySelector(this.selectors.section);
      section.insertAdjacentElement('beforebegin', markerTop);
      section.insertAdjacentElement('afterend', markerBottom);

      this.elements = {
        markers: document.querySelectorAll(this.selectors.marker),
        markerBottom: document.querySelector(this.selectors.markerBottom),
        section: section,
        header: this.querySelector(this.selectors.header),
      };

      this._initResizeObserver();

      window.addEventListener('scroll', this._handleScrollWindow);
      document.addEventListener('ce-sticky-scroll-header:freeze', this._handleFreeze);
      document.addEventListener('ce-sticky-scroll-header:unfreeze', this._handleUnfreeze);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._handleScrollWindow);
      document.removeEventListener('ce-sticky-scroll-header:freeze', this._handleFreeze);
      document.removeEventListener('ce-sticky-scroll-header:unfreeze', this._handleUnfreeze);

      this.intersectionObserver.disconnect();
      this.resizeObserver.disconnect();
    }

    _initResizeObserver() {
      const callback = () => {
        this.lastScrollY = window.scrollY;

        this.schedule = rafSchd((scrollY) => {
          if (this.attributesFrozen) {
            return;
          }

          if (scrollY > this.elements.markerBottom.offsetTop && scrollY > this.lastScrollY) {
            this.scrollDirection = 'down';
          } else {
            this.scrollDirection = 'up';
          }

          this.lastScrollY = scrollY;
        });

        this._initIntersectionObserver();
      };

      this.resizeObserver = new ResizeObserver(callback);
      this.resizeObserver.observe(this);
    }

    _initIntersectionObserver() {
      this.intersectionObserver?.disconnect();

      const callback = (entries) => {
        for (let entry of entries) {
          if (this.behavior === 'static' && entry.target.dataset.position === 'bottom' && !entry.isIntersecting) {
            this.behavior = 'sticky';
          }

          if (this.behavior === 'sticky' && entry.target.dataset.position === 'top' && entry.isIntersecting) {
            this.behavior = 'static';
          }
        }
      };

      this.intersectionObserver = new IntersectionObserver(callback);

      for (let marker of this.elements.markers) {
        this.intersectionObserver.observe(marker);
      }
    }

    _handleFreeze() {
      this.attributesFrozen = true;
    }

    _handleUnfreeze() {
      this.attributesFrozen = false;
    }

    _handleScrollWindow() {
      this.schedule(window.scrollY);
    }
  }

  customElements.define('ce-sticky-scroll-header', StickyScrollHeader);
})();
